import React from 'react';
import { HidingHeader } from 'hiding-header-react';
import DesktopHeader from './menus/desktop-header';
import 'hiding-header/dist/style.css';
import MobileHeader from './menus/mobile-header';

const Header: React.FC = () => (
    <>
        {/* <HidingHeader> */}
        <header
            css={{
                '@media (max-width: 767px)': {
                    display: 'none',
                },
                zIndex: '10',
                top: 0,
                position: 'sticky',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '20px 0',
                transition: 'padding 0.7s',
                backgroundColor: 'var(--color-shades-white)',
                '[aria-hidden="true"] &': {
                    padding: '0',
                    '@media (max-width: 1200px)': {
                        paddingLeft: '0',
                    },
                },
            }}
        >
            <DesktopHeader />
        </header>
        {/* </HidingHeader> */}
        <MobileHeader />
    </>
);

export default Header;
